import React, { createContext, useState } from 'react';

export const SelectedParamContext = createContext();
export const SetSelectedParamContext = createContext();

export const Provider = ({ children }) => {
  const [selectedParam, setSelectedParam] = useState(null);

  return (
    <SelectedParamContext.Provider value={selectedParam}>
      <SetSelectedParamContext.Provider value={setSelectedParam}>
        {children}
      </SetSelectedParamContext.Provider>
    </SelectedParamContext.Provider>
  );
};
